module.exports = __webpack_public_path__ + "img/hall.fab7b5aa.jpg";